<template>
	<div class="modal fade" :id="idDF" role="dialog" aria-labelledby="modal-campana-evento-label" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
		    <div class="modal-content">
		      	<div class="modal-header bg-primary">
		      		<div class="d-flex w-100 align-items-center">
			        	<h5 class="modal-title text-white" id="modal-campana-evento-label">
			        		Envíar campaña
			        	</h5>
						<button class="btn btn-sm btn-outline-light border ml-3 " v-on:click="addEvento" v-if="view=='index'">
							<i class="material-icons">add</i> Crear
						</button>
		      		</div>
		        	<div class="btn-group">
				        <button type="button" class="btn btn-link text-white btn-sm" data-dismiss="modal" aria-label="Close">
				        	<i class="material-icons">close</i>
				        </button>
		        	</div>
		    	</div>
		    	<preloader v-if="loading"></preloader>
		    	<div class="modal-body py-0">
		    		<div v-if="view=='index'">
		    			<div class="table-responsive" v-if="eventos.length>0">
							<table class="table table-borderless table-hover table-striped table-sm">
								<thead>
									<tr>
										<th>Evento</th>
										<th title="Correo electrónico" width="60">
											<i class="far fa-envelope"></i>
										</th>
										<th title="SMS" width="60">
											<i class="fas fa-comments"></i>
										</th>
										<th title="WhatsApp" width="60">
											<i class="fab fa-whatsapp"></i>
										</th>
										<th>Audiencia</th>
										<th></th>
									</tr>
									<tr>
										<td colspan="6" class="p-1">
											<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
												Envíos de campañas ({{eventos.length}})
											</div>
										</td>
									</tr>
								</thead>
								<tbody>
									<tr v-for="evento in eventos" class="cursor-pointer" v-on:click="showEvento(evento)">
										<th>
											<strong>{{evento.CODIGO_EVENTO}}</strong> |  {{evento.TITULO}}
										</th>
										<td align="center">
											<div v-if="evento.CORREO_ELECTRONICO == 1">
												<span class="text-success" title="Sí">
				                                    <i class="material-icons">check_circle</i>
				                                </span>
											</div>
											<div v-else>
												<span class="text-danger" title="No">
				                                    <i class="material-icons">block</i>
				                                </span>
											</div>
										</td>
										<td align="center">
											<div v-if="evento.SMS == 1">
												<span class="text-success" title="Sí">
				                                    <i class="material-icons">check_circle</i>
				                                </span>
											</div>
											<div v-else>
												<span class="text-danger" title="No">
				                                    <i class="material-icons">block</i>
				                                </span>
											</div>
										</td>
										<td align="center">
											<div v-if="evento.WHATSAPP == 1">
												<span class="text-success" title="Sí">
				                                    <i class="material-icons">check_circle</i>
				                                </span>
											</div>
											<div v-else>
												<span class="text-danger" title="No">
				                                    <i class="material-icons">block</i>
				                                </span>
											</div>
										</td>
										<td align="center">
											<div>{{evento.listado_count}}</div>
										</td>
										<td width="75">
											<button type="button" class="btn btn-sm btn-outline-primary" v-on:click.prevent.stop="send(evento.CODIGO_EVENTO)" v-if="evento.ESTADO==0">
												Envíar
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else>
							<empty icon="hourglass_empty" title="No hay información." description="No hay información relacionada a los envíos.">
							</empty>
						</div>
		    		</div>

		    		<div v-if="view=='create'">
		    			<EventosCreate :id="codigo" v-model="form" v-if="!form.CODIGO_EVENTO" @cancel="cancel"></EventosCreate>
		    			<Eventos :evento="form" @cancel="cancel" v-else></Eventos>
		    		</div>

		    		<div class="row py-3" v-if="false">
		    			<div class="col-md-3 mb-3">
		    				<label>Tipo de envío</label>
							<select class="custom-select" v-model="form.tipo">
								<option value="" disabled>Seleccionar tipo de envío</option>
								<option value="1">Emailing</option>
								<option value="2">WhatsApp, SMS</option>
							</select>
		    			</div>

		    			<div class="col-md-3 mb-3" v-if="form.tipo==1">
		    				<label>Segmento MailChimp</label>
		    				<div v-if="loadingSegmentos">
		    					Cargando...
		    				</div>
		    				<div class="input-group mb-3" v-else>
			    				<select class="custom-select" v-model="form.segmento_mailchimp">
			    					<option value="" disabled></option>
			    					<option v-for="segmento in segmentosMailchimp" :value="segmento.id">{{segmento.name}} ({{segmento.member_count}} miembros)</option>
			    				</select>
			    				<div class="input-group-append">
			    					<button class="btn btn-outline-secondary" type="button" v-on:click="getSegmentos()">
			    						<span class="material-icons">update</span>
			    					</button>
			    				</div>
			    			</div>
		    			</div>

    					<div class="col-md-3 mb-3" v-if="form.tipo==2">
			    			<label for="segmento">Segmento</label>
			    			<catalogo-segmentos id="segmento" v-model="form.segmento"></catalogo-segmentos>
    					</div>

		    			<div class="col-md-4 mb-3" v-if="form.tipo==2">
		    				<label for="estado_civil">Estado civil</label>
		    				<catalogo-estado-civil id="estado_civil" v-model="form.estadoCivil"></catalogo-estado-civil>
		    			</div>

		    			<div class="col-md-12 mb-3">
		    				<editor-texto v-model="form.html"></editor-texto>
		    			</div>

		    			<div class="col-md-12 mb-3" v-if="false">
		    				<preloader v-if="loadingClientes"></preloader>
		    				
		    				<div class="input-group mt-3 mb-2">
		    					<div class="input-group-prepend">
		    						<button class="btn btn-primary" type="button" id="button-addon" v-on:click="getClientes()">
		    							<i class="material-icons">update</i>
		    						</button>
		    					</div>
		    					<input type="text" class="form-control" placeholder="Buscar" aria-label="Buscar" aria-describedby="button-addon" v-model="search">
		    				</div>

		    				<div class="custom-control custom-switch" v-if="clientesFiltered.length>0">
    							<input type="checkbox" class="custom-control-input" id="all" v-model="allClientes">
    							<label class="custom-control-label" for="all" v-if="allClientes==true">
    								Seleccionar todos los clientes
    							</label>
    							<label class="custom-control-label" for="all" v-else>
    								Deseleccionar todos los clientes
    							</label>
    						</div>

		    				<ul class="list-group" v-if="clientesFiltered.length>0">
		    					<li class="list-group-item d-flex justify-content-between align-items-center" v-for="cliente in clientesFiltered">
		    						<div class="custom-control custom-switch">
		    							<input type="checkbox" class="custom-control-input" :id="'cliente'+cliente.CODIGO_CLIENTE" v-model="form.clientes" :value="cliente">
		    							<label class="custom-control-label" :for="'cliente'+cliente.CODIGO_CLIENTE">
		    								{{cliente.NOMBRE_CLIENTE}}
		    								<div class="d-flex justify-content-between text-truncate">
		    									<span :class="{'badge':true, 'badge-dark':cliente.EMAIL, 'badge-danger':!cliente.EMAIL}">
		    										{{cliente.EMAIL || 'Sin correo'}}
		    									</span>
		    									<span :class="{'badge ml-2':true, 'badge-light':cliente.CELULAR, 'badge-danger':!cliente.CELULAR}">
		    										{{cliente.CELULAR || 'Sin teléfono'}}	
		    									</span>
		    								</div>
		    							</label>
		    						</div>
		    					</li>
		    				</ul>
		    				<div v-else>
		    					<empty icon="hourglass_empty" title="No hay clientes." description="No hay información relacionada a los clientes.">
		    					</empty>
		    				</div>
		    			</div>
		    		</div>
		    	</div>

		    	<div class="modal-footer" v-if="false">
		    		<button type="button" class="btn btn-primary" v-on:click="closeModal()">
		    			Cancelar
		    		</button>

		    		<button type="button" class="btn btn-primary" v-on:click="store()">
		    			Envíar
		    		</button>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<script>
	import Eventos from './Eventos.vue'
	import EventosCreate from './envios/Create.vue'
	export default {
		props: ['id'],

		components: {
			Eventos,
			EventosCreate
		},

		data(){
			return {
				loading: false,
				
				search: '',
				codigo: 0,
				errors: {},
				eventos: [],
				view: 'index',
				//evento: {},
				form: {}
			}
		},

		mounted() {
			this.getData()
			var vm = this
			$(this.$el).on('shown.bs.modal', function (event) {
				var button = $(event.relatedTarget)
				var cliente = button.data('campana')
				vm.errors = {}
				vm.view = "index"
				vm.codigo = cliente
				vm.form = {}
				vm.getData()
				//vm.form.code = new Date().getTime()
				//vm.getClientes()
				//vm.getSegmentos()
			})
		},

		methods: {
			getData(){
				this.loading = true
				axios.get(`api/campanas/${this.codigo}/eventos`).then(x => {
					this.eventos = x.data
				}).catch(err => {
					//
				}).then(()=>{
					this.loading = false
				})
			},

			addEvento(){
				this.errors = {}
				this.loading = false
				this.form = {}
				this.view = 'create'
			},

			showEvento(evento){
				//console.log(evento)
				this.view = 'create'
				this.form = evento
				//this.form.code = evento.CODIGO_EVENTO
			},

			showModal(){
				$(this.$el).modal('show')
			},

			closeModal(){
				$(this.$el).modal('hide')
			},
			cancel(val){
				if (val) {
					this.getData()
					this.view = 'index'
				}
			},
			send(code){
				axios.post('api/campanas/eventos/'+code+'/send').then(res => {
					this.$toasted.show('Envíado con éxito.')
				}).catch(err => {
					this.$toasted.show('Error al envíar.')
					console.log(err.response)
				}).then(()=>{
					//this.loadingClientes = false
				})
			}
		},

		computed: {
			idDF(){
				return this.id || 'modalCampanaEvento'
			},
		},
	}
</script>